<div class="signature-container">
  <div class="signature-row">
    <strong class="signature-title">Internal Signature</strong>
    <span
      class="signature-name"
      *ngIf="signaturePreviewInternal"
      title="{{ signatureNameInternal }}"
    >
      <strong>Signature:</strong>
      {{ signatureNameInternal | limitString: 40 : '...' }}
    </span>
  </div>
  <div class="signature-section">
    <br />
    <div
      *ngIf="!loadingIndicatorInternal && emptyStateInternal"
      class="cw-signature-preview-signature signature-empty-state"
    >
      {{ noSignaturesMessage }}
    </div>
    <div
      *ngIf="!loadingIndicatorInternal && !emptyStateInternal"
      class="cw-signature-preview-signature"
      [innerHTML]="signaturePreviewInternal"
    ></div>

    <div *ngIf="loadingIndicatorInternal" class="cw-dialog-status cw-signature-preview-signature">
      <div class="saving-text">
        <div>Generating signature...</div>
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        <div class="sig-preview-cancel" (click)="cancelPreviewInternal()">CANCEL</div>
      </div>
    </div>
  </div>

  <div class="signature-row">
    <strong class="signature-title">External Signature</strong>
    <span
      class="signature-name"
      *ngIf="signaturePreviewExternal"
      title="{{ signatureNameExternal }}"
    >
      <strong>Signature:</strong>
      {{ signatureNameExternal | limitString: 40 : '...' }}
    </span>
  </div>
  <div class="signature-section">
    <br />
    <div
      *ngIf="!loadingIndicatorExternal && emptyStateExternal"
      class="cw-signature-preview-signature signature-empty-state"
    >
      {{ noSignaturesMessage }}
    </div>
    <div
      *ngIf="!loadingIndicatorExternal && !emptyStateExternal"
      class="cw-signature-preview-signature"
      [innerHTML]="signaturePreviewExternal"
    ></div>

    <div *ngIf="loadingIndicatorExternal" class="cw-dialog-status cw-signature-preview-signature">
      <div class="saving-text">
        <div>Generating signature...</div>
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        <div class="sig-preview-cancel" (click)="cancelPreviewExternal()">CANCEL</div>
      </div>
    </div>
  </div>
</div>
